'use client';

import Image from 'next/image';
import LoopIcon from '../../../../public/svg/loop.svg';
import { useRouter } from 'next/navigation';
import { useRef } from 'react';
import { AppConfig } from '@/utils/AppConfig';

interface Props {
  styles?: string;
  showInput?: boolean;
  callback?: () => void;
}

export const SearchMenu = ({ showInput = true, styles, callback }: Props) => {
  const router = useRouter();
  const searchInputRef = useRef<HTMLInputElement>(null);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const searchValue = searchInputRef.current?.value;
    const queryParam = searchValue
      ? `?search=${encodeURIComponent(searchValue)}&${encodeURIComponent(AppConfig.searchIndexGlobal + '[query]')}=${encodeURIComponent(searchValue)}`
      : '';
    router.push(`/recherche${queryParam}`);
    if (callback) {
      callback();
    }
  };

  return (
    <form
      onSubmit={handleSearch}
      className={`relative flex h-full items-center justify-center rounded-lg ${styles}`}
    >
      {showInput && (
        <input
          ref={searchInputRef}
          type="text"
          placeholder="Rechercher"
          className="input input-bordered w-full max-w-xs rounded-[100px] pr-11 text-sm font-bold text-slate-950 placeholder-slate-950 outline-none hover:text-black focus:text-black focus:outline-none"
        />
      )}
      <button className={`h-[25px] w-[25px] ${showInput ? 'absolute right-[15px]' : ''}`}>
        <Image
          src={LoopIcon}
          alt="Rechercher"
          width={25}
          height={25}
          className="relative bottom-[1px] right-[1px]"
        />
      </button>
    </form>
  );
};
